import React, { useContext, useState, useEffect } from 'react'
import Button from '@veneer/core/dist/scripts/button'
import useContentStack from '@/hooks/useContentStack'
import { useNextStage } from '@/hooks/useNextStage'
import { PrinterContext } from '@/store'
import {
  CONTENT_STACK_TYPES,
  ANALYTICS,
  MULTI_FUNCTION_PRINTER
} from '@/store/Constants'
import GenericModal, {
  GENERIC_MODAL_TYPES
} from '@/components/UI/Modals/GenericModal'
import { IconCheckmark } from '@veneer/core/dist/scripts/icons'
import { PageHeader, ButtonsFooter } from '@/components/UI/Smallville'

import classes from './CloudValuePropPage.module.scss'
import useAnalytics from '@/hooks/useAnalytics'
import { usePrinterDetailsApp } from '@/hooks/usePrinterDetailsApp'
import { Logger } from '@/utils/Logger'

const { BUTTONS, SCREENS, MODES } = ANALYTICS

export function CloudValuePropPage() {
  const [openModal, setOpenModal] = useState(false)

  const { fireScreenDisplayed, fireButtonClick } = useAnalytics(
    SCREENS.CLOUD_VALUE_PROP
  )
  const { printerFunctionType, resetPrinterData, loadedFromStore } = useContext(
    PrinterContext
  )

  const { handlePrinterDetailsApp } = usePrinterDetailsApp()
  const { dispatchSuccessStage } = useNextStage()
  const { pageData, startQuery } = useContentStack({
    queryOnInit: false
  })

  const handleContinue = () => {
    fireButtonClick(BUTTONS.CONTINUE)
    dispatchSuccessStage()
  }

  const handleExit = () => {
    fireButtonClick(BUTTONS.SKIP)
    setOpenModal(true)
  }

  useEffect(() => {
    if (loadedFromStore) {
      resetPrinterData()
    }
  }, [loadedFromStore])

  useEffect(() => {
    handlePrinterDetailsApp().catch((error) => {
      Logger.error('Error trying to get printer details printer', error)
    })
  }, [])

  useEffect(() => {
    if (printerFunctionType == null) return
    startQuery({
      content_type: CONTENT_STACK_TYPES.landing_page_app,
      additional_params: {
        printer_function_type: printerFunctionType
      }
    })
    triggerScreenDisplayedEvent()
  }, [printerFunctionType])

  const triggerScreenDisplayedEvent = (force = false) => {
    fireScreenDisplayed({
      mode:
        printerFunctionType === MULTI_FUNCTION_PRINTER
          ? MODES.SCREEN.MULTI_FUNCTION
          : MODES.SCREEN.SINGLE_FUNCTION,
      force
    })
  }

  if (!pageData) {
    return null
  }

  return (
    <>
      <div
        data-testid="landing-page-smallville"
        className={classes.landingPageSmallville}
      >
        <PageHeader
          header={pageData.header}
          description={pageData.description}
        />
        <div className={classes.content}>
          <section className={classes.features}>
            <h6>{pageData.features.title}</h6>
            <ul>
              {pageData.features.list.map((feature) => (
                <li key={feature}>
                  <IconCheckmark size={24} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </section>
          <section className={classes.printerImage}>
            <img
              alt={pageData.printer_function_image.title}
              src={pageData.printer_function_image.url}
            />
          </section>
        </div>
        <ButtonsFooter>
          <Button appearance="secondary" onClick={handleExit}>
            {pageData.buttons.exit}
          </Button>
          <Button appearance="secondary" onClick={handleContinue}>
            {pageData.buttons.continue}
          </Button>
        </ButtonsFooter>
      </div>
      <GenericModal
        type={GENERIC_MODAL_TYPES.EXIT_HP_CLOUD_CONNECTION}
        visible={openModal}
        setVisibility={setOpenModal}
        onClose={() => triggerScreenDisplayedEvent(true)}
      />
    </>
  )
}
